module.exports = __webpack_public_path__ + "0979f8d9e2aa95481dbaf30833d57c79.pdf";